import { render, staticRenderFns } from "./CommentsFeed.vue?vue&type=template&id=14bb795e&scoped=true&"
import script from "./CommentsFeed.vue?vue&type=script&lang=ts&"
export * from "./CommentsFeed.vue?vue&type=script&lang=ts&"
import style0 from "./CommentsFeed.vue?vue&type=style&index=0&id=14bb795e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bb795e",
  null
  
)

export default component.exports